import { makeVar } from "@apollo/client";

import {
  OrderByDirection,
  SimilarPlayerSortField,
  SortField,
  SortOrder,
} from "@/generated/graphql";

/**
 *
 */
export type MenuSelectionSortType = SortField | SimilarPlayerSortField;
/**
 *
 */
export type MenuSortOrder = OrderByDirection | SortOrder;

/**
 *
 */
export interface IMenuSelection {
  title: string;
  type: MenuSelectionSortType;
}

/**
 *
 */
export interface IMenuSort {
  sortBy: MenuSelectionSortType;
  sortOrder?: MenuSortOrder;
}

export const menuSelectionSortList: IMenuSelection[] = [
  {
    title: "GPR",
    type: SortField.Gpr,
  },
  {
    title: "Player Style",
    type: SortField.FitScore,
  },
  {
    title: "Team Style",
    type: SortField.TeamStyleFit,
  },
  {
    title: "Carrying",
    type: SortField.Carrying,
  },
  {
    title: "Dribbling",
    type: SortField.Dribbling,
  },
  {
    title: "Passing",
    type: SortField.Passing,
  },
  {
    title: "Shooting",
    type: SortField.Shooting,
  },
  {
    title: "GK Passing",
    type: SortField.GkPassing,
  },
  {
    title: "Positioning",
    type: SortField.GkPositioning,
  },
  {
    title: "Shot Stopping",
    type: SortField.GkShotStopping,
  },
  {
    title: "Transfer Value",
    type: SortField.PlayerValuation,
  },
  {
    title: "Months Remaining",
    type: SortField.MonthsRemaining,
  },
];

export const menuSelectionSortSimilarityList: IMenuSelection[] = [
  {
    title: "Similarity",
    type: SimilarPlayerSortField.SimilarityScore,
  },
  {
    title: "GPR",
    type: SimilarPlayerSortField.Gpr,
  },
  {
    title: "Player Style",
    type: SimilarPlayerSortField.FitScore,
  },
  {
    title: "Team Style",
    type: SimilarPlayerSortField.TeamStyleFit,
  },
  {
    title: "Carrying",
    type: SimilarPlayerSortField.Carrying,
  },
  {
    title: "Dribbling",
    type: SimilarPlayerSortField.Dribbling,
  },
  {
    title: "Passing",
    type: SimilarPlayerSortField.Passing,
  },
  {
    title: "Shooting",
    type: SimilarPlayerSortField.Shooting,
  },
  {
    title: "GK Passing",
    type: SimilarPlayerSortField.GkPassing,
  },
  {
    title: "Positioning",
    type: SimilarPlayerSortField.GkPositioning,
  },
  {
    title: "Shot Stopping",
    type: SimilarPlayerSortField.GkShotStopping,
  },
  {
    title: "Transfer Value",
    type: SimilarPlayerSortField.PlayerValuation,
  },
  {
    title: "Months Remaining",
    type: SimilarPlayerSortField.MonthsRemaining,
  },
];

export const watchlistShowVar = makeVar<IMenuSelection>({
  title: "GPR",
  type: SortField.Gpr,
});

export const similarityShowVar = makeVar<IMenuSelection>({
  title: "Similarity",
  type: SimilarPlayerSortField.SimilarityScore,
});

export const watchlistSortVar = makeVar<IMenuSort | undefined>(undefined);

export const similaritySortVar = makeVar<IMenuSort | undefined>(undefined);

export const shouldClosePopoverVar = makeVar<number>(0);
